import React from "react";
import AreYouSureImage from "../images/AreYouSureImage";
import random from "../images/random.png";

const AreYouSureModal = ({
  no,
  yes,
  noFunction,
  yesFunction,
  yesParam,
  message,
}) => {
  return (
    <div className="overlay z-50">
      <div className="modal !justify-center  ">
        <div>
          <img
            src={random}
            width="45"
            height="45"
            alt="random"
            className=" mb-3 p-0 ml-auto mr-auto"
          />
        </div>

        <p className=" text-sm !mb-0 text-[#00394d]">
          {" "}
          {/* <span className="">
            <IoAlertCircleOutline
              style={{ fontSize: "23px", color: "#00394d" }}
            />
          </span> */}
          <span className=" font-semibold"> Are you sure?</span>
        </p>
        <p className="text-xs p-1 mb-2 text-[#00394d]">
          {message
            ? message
            : "This action cannot be undone, All values associated with this field will be deleted."}
        </p>
        <div className="text-[14px] flex justify-between mt-1">
          <button
            className="rounded bg-[#f0f0f0] text-[#838991] w-[100px] py-[10px] hover:bg-[#f7f7f7]"
            onClick={noFunction}
          >
            {no}
          </button>
          <button
            className="bg-[#a0ff77] text-[#00394d] w-[100px] py-[10px] rounded font-medium hover:bg-[#7af545] "
            onClick={() => {
              yesFunction(yesParam);
            }}
          >
            {yes}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AreYouSureModal;
